// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CrosshairIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CrosshairIcon" ref={forwardedRef} {...props}>
      <path d="M3.5 5.422V3.498h1.929v-1.5H3a1 1 0 0 0-1 1v2.424z" />
      <path d="M16.5 3.498h-1.929v-1.5H17a1 1 0 0 1 1 1v2.424h-1.5z" />
      <path d="M16.5 14.569H18v2.429a1 1 0 0 1-1 1h-2.429v-1.5H16.5z" />
      <path d="M5.429 16.498H3.5v-1.929H2v2.429a1 1 0 0 0 1 1h2.429z" />
      <path d="M14.5 10.748h-3.75V14.5h-1.5v-3.752H5.5v-1.5h3.75V5.5h1.5v3.748h3.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CrosshairIcon = /* @__PURE__ */ Object.assign(
  CrosshairIconComponent,
  { displayName: 'CrosshairIcon' },
);
